import { render, staticRenderFns } from "./Tadbirkorlik.vue?vue&type=template&id=1841561d&scoped=true&"
import script from "./Tadbirkorlik.vue?vue&type=script&lang=js&"
export * from "./Tadbirkorlik.vue?vue&type=script&lang=js&"
import style0 from "./Tadbirkorlik.vue?vue&type=style&index=0&id=1841561d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841561d",
  null
  
)

export default component.exports